import Table from './table';
import selectTableHOC from "./hoc/selectTable";

const SelectTable = selectTableHOC(Table);

export { Table, SelectTable };